const updates = [
  {
    time: '10分钟前',
    title: '台北娜娜新视频评论区炸了，网友热议不断',
    tag: '最新',
  },
  {
    time: '45分钟前',
    title: '莫里秀神秘发文暗示新内容即将发布',
    tag: '预告',
  },
  {
    time: '1小时前',
    title: '玩偶姐姐社交账号更新，粉丝疯狂解读',
    tag: '动态',
  },
  {
    time: '2小时前',
    title: '娱乐圈再曝大瓜，多位明星卷入风波',
    tag: '爆料',
  },
  {
    time: '3小时前',
    title: '台北娜娜与神秘人物同框照片流出',
    tag: '独家',
  },
  {
    time: '5小时前',
    title: '莫里秀过往视频播放量突破千万大关',
    tag: '里程碑',
  },
  {
    time: '7小时前',
    title: '51吃瓜app日活跃用户再创新高',
    tag: '平台',
  },
  {
    time: '9小时前',
    title: '吃瓜群众热评：本月最佳爆料TOP5出炉',
    tag: '排行',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            最新快讯
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            实时更新的吃瓜动态，永远快人一步
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300" />
          <div className="space-y-4">
            {updates.map((item, i) => (
              <div key={i} className="relative flex items-start gap-4 pl-12">
                <span
                  className={`absolute left-[11.5px] top-2 w-4 h-4 rounded-full border-2 border-background-50 bg-background-50 ${
                    i === 0
                      ? 'ring-2 ring-primary-400 bg-primary-500 border-primary-500'
                      : 'bg-background-300 border-background-300'
                  }`}
                />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="text-xs text-foreground-400">{item.time}</span>
                    <span
                      className={`px-2 py-0.5 text-[10px] font-medium rounded-full ${
                        i === 0
                          ? 'bg-primary-100 text-primary-700'
                          : 'bg-secondary-100 text-secondary-700'
                      }`}
                    >
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed cursor-pointer hover:text-primary-500 transition-colors">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}